// extracted by mini-css-extract-plugin
export default {"videoContainer":"styles_videoContainer__8hhPa","videoContainerInner":"styles_videoContainerInner__ZBmyt"};